/** Old Reports > RSW list: RSW and CSW reports are one list now (user, 2026-10-16). */
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/reports/rsw/")({
  beforeLoad: () => {
    throw redirect({ to: "/reports/warehouse", replace: true });
  },
});
